/* eslint-disable jsx-a11y/interactive-supports-focus */

// product card option component
export const ItemCard = ({ itemDetails }) => {
  const { slug, title, unit, price, image, subtitle } = itemDetails || {};
  return (
    <div
      className={`tw-border !tw-border-x-0 !tw-border-b-0 tw-border-solid tw-border-grey-200`}
    >
      <div className='tw-flex-col tw-w-full tw-gap-4 tw-p-3'>
        <div className='tw-flex tw-items-start tw-justify-between tw-w-ful tw-gap-2'>
          <div className='tw-flex tw-w-full'>
            <div className='tw-w-[4rem] tw-h-[4rem] tw-border tw-border-solid tw-border-grey-200/50 tw-overflow-hidden tw-rounded-lg tw-mr-4'>
              <img
                src={image}
                alt={title || slug}
                className='tw-h-[4rem] tw-w-[4rem]'
              />
            </div>

            <div className='tw-flex tw-flex-col tw-flex-1 tw-gap-1'>
              <div className='tw-font-medium tw-text-[1.2rem] tw-text-zinc-800 tw-leading-tight'>
                {title}
              </div>
              <div className='tw-flex tw-items-center tw-gap-2 tw-font-medium tw-text-[1.3rem] !tw-text-zinc-700'>
                {subtitle && (
                  <div className='tw-text-zinc-500 tw-text-[1.3rem]'>
                    {subtitle}
                  </div>
                )}{' '}
                {price && '|'}
                {price && <div className='tw-text-[1.3rem]'>₹{price}</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
